import { Image } from '@customerio/pluma-components/react';
import logoForest from '@/assets/images/logos/logo-forest.svg';
import logoWhite from '@/assets/images/logos/logo-white.svg';

interface LogoProps {
  width?: number;
  className?: string;
}

export function Logo({ width = 160, className }: LogoProps) {
  return (
    <Image
      src={[
        { src: logoForest, colorScheme: 'light' },
        { src: logoWhite, colorScheme: 'dark' },
      ]}
      alt="Customer.io"
      width={width}
      className={className}
    />
  );
}
